<template>
    <div class="lang">
        <a class="lang__item" :class="{ current: this.$i18n.locale == 'en' }" href="#" @click.prevent="setLang('en')">en</a>
        <a class="lang__item" :class="{ current: this.$i18n.locale == 'lv' }" href="#" @click.prevent="setLang('lv')">lv</a>
        <a class="lang__item" :class="{ current: this.$i18n.locale == 'ru' }" href="#" @click.prevent="setLang('ru')">ru</a>
    </div>
</template>


<script>
    export default {
        methods: {
            setLang(lang) {
                this.$i18n.locale = lang
            }
        }
    }
</script>


<style lang="scss">
    $lang-bg: #21282d;

    .lang {
        display: flex;
        background-color: $lang-bg;

        position: absolute;
        top: 6.5rem;
        right: 0;
        z-index: 1;

        transform: translate3d(100%, 0, 0);
        backface-visibility: hidden;

        animation: lang-slide-in .25s linear forwards 2.2s;

        @media (max-width: 767px) {
            top: 4.5rem;
        }
    }

    .lang__item {
        padding: 1rem;

        font-size: 1rem;
        text-transform: uppercase;
        color: #fff;
        font-weight: 700;
        text-decoration: none;

        transition: background .1s linear;

        &:hover:not(.current) {
            background-color: lighten($lang-bg, 5%);
        }

        &.current {
            color: var(--red);
        }

        @media (max-width: 1199px) {
            padding: .75rem;
            font-size: .8rem;
        }
    }

    @keyframes lang-slide-in {
        0% {
            transform: translate3d(100%, 0, 0);
        }

        100% {
            transform: translate3d(0, 0, 0);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Lang.vue